import { Module } from "vuex";
import { RootState } from "@/store/index";
import { IDocumentType, TClientDoc } from "@/types/docTypes";
import { axios } from "@/plugins/http-axios";
import { api } from "@/plugins/request";
import { uri } from './uri';
import type { HistoryResponse } from "@/interfaces/History";
import type ExtendedAxiosError from '@/interfaces/ExtendedAxiosError';

interface IAppState {
  requestFl: IdividualRequest
  individualRequests: IdividualRequest[]
  count: number
  individualRequetDocuments: TClientDoc[]
  history: HistoryResponse
  requestFieldDocumentTypes: IDocumentType[];
}

interface IndividualRequests {
  content: IdividualRequest[]
  count: number
}

interface AgentInfo {
  id: string
  shortName: string
  fullName: string
  createDate: string
  contractDate: string
  contractNumber: string
  location: string
  inn: string
  ogrn: string
  kpp: string
  positionEio: string
  fioEio: string
  phoneEio: string
}
interface ActionType {
  [key:string]: string
}
export interface IdividualRequest {
  id: string
  number: number
  agent: AgentInfo
  agentName: string
  clientName: string
  createDate: string
  modifyDate: string
  comment: string
  status: string
  processKey: string
  clientId: string
  clientInn: string
  sum: string
  action: ActionType
}


export default <Module<IAppState, RootState>>{
  namespaced: true,
  state: {
    requestFl: {
      id: "",
      number: 1,
      agentName: "",
      clientName: "",
      createDate: "",
      modifyDate: "",
      comment: "",
      status: "",
      processKey: "",
      clientId: "",
      clientInn: "",
      sum: "",
      agent: {
        id: "",
        shortName: "",
        fullName: "",
        createDate: "",
        contractDate: "",
        contractNumber: "",
        location: "",
        inn: "",
        ogrn: "",
        kpp: "",
        positionEio: "",
        fioEio: "",
        phoneEio: ""
      },
      action: {}
    },
    individualRequests: [],
    count: 0,
    individualRequetDocuments: [],
    history: {
      content: [],
      count: 0
    },
    requestFieldDocumentTypes: [],
  },
  mutations: {
    setFieldDocumentRequestFlTypes(state, payload) {
      state.requestFieldDocumentTypes = payload;
    },
    setIndividualRequestsAll(state, payload: IndividualRequests) {
      state.individualRequests = payload.content;
      state.count = payload.count;
    },
    setRequestFl(state, payload) {
      state.requestFl = payload;
    },
    setRequestIndividualDocs(state, payload: TClientDoc[]) {
      state.individualRequetDocuments = payload;
    },
    setStorageHistory(state, payload: HistoryResponse) {
      state.history.content = payload.content;
    },
  },
  actions: {
    async requestIndividualStorageRequestAll({ commit, dispatch }, filter) {
      dispatch('setLoader', { show: true, message: 'Загрузка заявок', manual: true }, { root: true });
      const response = await api.post<IndividualRequests>({url: uri.individualRequestsAll, body: filter});
      const { data } = response;
      if (data) {
        commit('setIndividualRequestsAll', data);
        commit('setTotalCount', data.count, { root: true });
      }
      dispatch('setLoader', { show: false, message: 'Загрузка заявок', manual: true }, { root: true });
      return response;
    },

    async requestSaveFilterIndividualRequest({ dispatch }, filterRequest) {
      const response = await api.post<null>({url: uri.saveFilter('application'), body: filterRequest});
      return response;
    },

    async requestIndividualStorageRequest({ commit, dispatch }, id) {
      const response = await api.get<IdividualRequest>({url: uri.storageRequestIndividualFind(id)});
      const { data } = response;
      if (data) {
        commit('setRequestFl', data);
      }
      return response;
    },

    async requestStorageDocumentsFromDelegate({ commit, dispatch }, id) {
      try {
        const response = await api.get<TClientDoc[]>({url: uri.storageRequestDocs(id)});
        const { data } = response;
        if (data) {
          commit('setRequestIndividualDocs', data);
        }
        return response;
      } catch (error) {
        dispatch('setError', error, { root: true });
        return error;
      }
    },

    async requesStorageHistory({ commit, dispatch, getters }) {
      const history = {
        targetId: getters.getIndividualRequestId,
        sorted: { field: "", orderBy: "" }
      };
      const response = await api.post<HistoryResponse>({url: uri.eventsList, body: history});
      const { data } = response;
      commit('setStorageHistory', data);
      return response;
    },

    async requestSaveStorageFl({ dispatch, getters }, requestFl) {
      const response = await api.put<null>({url: uri.applicationEdit(getters.getIndividualRequestId),body: requestFl});
      await dispatch('requestIndividualStorageRequest', getters.getIndividualRequestId);
      await dispatch('requesStorageHistory');
      return response;
    },

    async requestdownloadBinaryDocument({ dispatch }, id) {
      try {
        const response = await api.get<string>({url: uri.downloadStorageFileId(id), responseType: 'blob' });
        return response;
      } catch (e) {
        const error = e as ExtendedAxiosError<null>;
        await dispatch('setError', error, { root: true });
      }
    },
    async requestFieldDocumentRequestFlTypes({ commit, dispatch }, id) {
      const response = await api.get({url: uri.storageRequestFieldDocumentTypes(id)});
      const { data } = response;
      if (data) {
        commit('setFieldDocumentRequestFlTypes', data);
      }
      return response;
    },

    async requestDeleteIndividualRequest({ dispatch }, id) {
      const response = await api.delete({url: uri.applicationEdit(id)});
      const { status } = response;
      if (status === 200) {
        dispatch('addSuccess', { message: 'Заявка удалена' }, { root: true });
      }
      return response;
    },

    async requestUploadToTmpFiles({ dispatch, getters }, formData) {
      try {
        const response = await api.post({url: uri.storageRequestTemporaryDocumenun(getters.getIndividualRequestId), body: formData});
        return response;
      } catch (error) {
      }
    },

    async requestUploadToTmpFilesAddDoc({ dispatch, getters }, formData) {
      const response = await api.post({ url: uri.storageRequestTemporaryDocumenun(getters.getIndividualRequestId), body: formData});
      return response;
    },

    async requestUploadFromTmpToDocumentTable({ dispatch, getters }, formData) {
      const response = await api.post({ url: uri.storageRequestUploadDocument(getters.getIndividualRequestId), body: formData});
      return response;
    },

    async requestSendAction({ dispatch }, action) {
      const response = await api.post({url: uri.applicationAction, body: action})
      return response
    },
  },
  getters: {
    getApplication: ({ requestFl }) => requestFl,

    getIndividualRequestId: ({ requestFl }) => requestFl.id,

    getIndividualRequestFieldDocumentTypes: (state): IDocumentType[] => state.requestFieldDocumentTypes,

    getIndividualRequetDocuments: ({ individualRequetDocuments }) => individualRequetDocuments,

    getIndividualRequests: ({ individualRequests }) => individualRequests,

    getIndividualRequestCount: ({ count }) => count,


    getIndividualRequestHistory: ({ history }) => history.content,
  },
};
